import React, { Component, PropTypes } from 'react';
import withTooltip from '../ui/sabre-spark-react-ex/tooltip';

class LinkIconTemplate extends Component {
    render() {
        const { disable, iconType, showTooltip, tooltipValue, onClick } = this.props;

        return (
            <a className={`spark-margin-right-6 ${disable && 'disabled'}`} disabled={disable} onClick={onClick}>
                <i className={iconType + ' spark-icon--md'} />
                {showTooltip && tooltipValue && (
                    <span className={'spark-tooltip__content--bottom'} role="tooltip">
                        {tooltipValue}
                        <span className="spark-tooltip__caret"></span>
                    </span>
                )}
            </a>
        );
    }
}

const LinkIconTooltip = withTooltip(undefined, 'top')(LinkIconTemplate);

LinkIconTemplate.propTypes = {
    iconType: PropTypes.string,
    disable: PropTypes.bool,
    onClick: PropTypes.func,
    showTooltip: PropTypes.bool,
    tooltipValue: PropTypes.string
};

LinkIconTemplate.defaultProps = {
    iconType: '',
    disable: false,
    onClick: () => {},
    showTooltip: false
};

export class LinkIcon extends Component {
    translateIconTypeToTooltipText(iconType) {
        switch (iconType) {
            case 'spark-icon-info-circle':
                return 'Version history';
            case 'spark-icon-password-view':
                return 'View';
            case 'spark-icon-pencil':
                return 'Edit';
            case 'spark-icon-documents':
                return 'Make a copy';
            case 'spark-icon-trash':
                return 'Delete';
            default:
                return '';
        }
    }

    render() {
        const tooltipValue = this.translateIconTypeToTooltipText(this.props.iconType);

        return this.props.showTooltip && tooltipValue ? (
            <LinkIconTooltip {...this.props} tooltipValue={tooltipValue} />
        ) : (
            <LinkIconTemplate {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assets/LinkIcon.js